module.exports = __webpack_public_path__ + "static/media/apartment10.94b9a252.jpg";